import config from '../config';
var CalendarService = /*@__PURE__*/ (function () {
    function CalendarService() {
    }
    CalendarService.getFreeslots = function (rmsID, startDate, endDate) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/calendar/freeslots/" + rmsID + "?startdate=" + startDate + "&enddate=" + endDate,
                success: function (res) {
                    resolve(res);
                },
                error: function () {
                    reject();
                }
            });
        });
    };
    CalendarService.getFreeslotsByApmType = function (rmsID, startDate, endDate, apmType) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/calendar/freeslots/" + rmsID + "?startdate=" + startDate + "&enddate=" + endDate + "&appointmenttype=" + apmType,
                success: function (res) {
                    resolve(res);
                },
                error: function () {
                    reject();
                }
            });
        });
    };
    return CalendarService;
}());
export default CalendarService;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/service/Calendar.ts
// module id = null
// module chunks = 